import { Delete } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CarService from "app/apis/Goeasy/Car/CarService";
import BreadCrumbs from "app/components/Breadcrumbs/Breadcrumbs";
import { PrimaryButton } from "app/components/Buttons/Button";
import AddNewCar from "app/components/Dialog/AddNewCar";
import { ErrorToaster, SuccessToaster } from "app/components/Toaster/Toaster";
import Layout from "app/layout/Layout";
import colors from "app/styles/colors";
import React, { useEffect, useState } from "react";

function ManageCars() {
  const [dataList, setDataList] = useState([]);
  const [listLoader, setListLoader] = useState(true);
  const [selectedData, setSelectedData] = useState();
  const [showDialog, setShowDialog] = useState(false);

  const getAllCars = async () => {
    try {
      setShowDialog(false);
      let { data, success } = await CarService.getCarBooking();
      if (success) {
        setDataList(data);
      }
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setListLoader(false);
    }
  };

  const deleteItem = async (id) => {
    try {
      let { success } = await CarService.deleteCarBooking({ id });
      if (success) {
        getAllCars();
      }
      SuccessToaster("Car deleted successfully");
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getAllCars();
  }, []);
  return (
    <Layout>
      <AddNewCar
        handleClose={() => setShowDialog(false)}
        open={showDialog}
        handleSubmitFunc={getAllCars}
      />
      <Box
        sx={{ backgroundColor: colors.lightGray, p: 3, borderRadius: "12px" }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ bgcolor: colors.white, p: 2, borderRadius: "12px" }}
        >
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">
              Manage Cars
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage="Manage Cars" />
          </Grid>
        </Grid>

        <Box
          sx={{
            mt: 2,
            bgcolor: colors.white,
            p: 2,
            borderRadius: 4,
            textAlign: "right",
          }}
        >
          <PrimaryButton
            onClick={() => setShowDialog(true)}
            title="Add New Car"
          />
        </Box>

        <Box sx={{ mt: 2, bgcolor: colors.white, p: 2, borderRadius: 4 }}>
          {listLoader ? (
            <Box sx={{ textAlign: "center" }}>
              <CircularProgress color="success" />
            </Box>
          ) : (
            <>
              <TableContainer component={Paper} sx={{ my: 2 }}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow sx={{ bgcolor: colors.primary }}>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Image
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Brand
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Type
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Model
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Plate Number
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Seating Capacity
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Transmission
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Year
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Per Day Rate
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataList?.map((row, index) => (
                      <TableRow
                        sx={{
                          bgcolor: index % 2 ? colors.lightGray : "white",
                        }}
                        key={row.user_name}
                      >
                        <TableCell>
                          <img
                            src={row?.image}
                            alt="vehicle"
                            width={50}
                            height={50}
                          />
                        </TableCell>
                        <TableCell>{row?.brand ?? "-"}</TableCell>
                        <TableCell>{row?.type ?? "-"}</TableCell>
                        <TableCell>{row?.model ?? "-"}</TableCell>
                        <TableCell>{row?.vehicle_no ?? "-"}</TableCell>
                        <TableCell>{row?.seating_capacity ?? "-"}</TableCell>
                        <TableCell>{row?.transmission ?? "-"}</TableCell>
                        <TableCell>{row?.year ?? "-"}</TableCell>
                        <TableCell>{row?.per_day_rate ?? "-"}</TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex" }}>
                            <IconButton
                              onClick={() => deleteItem(row?.id)}
                              size="small"
                            >
                              <Delete color="error" />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </Box>
      </Box>
    </Layout>
  );
}

export default ManageCars;
